import styled from 'styled-components';
import { spacing, base } from '@alinta-digital/asg';
import { addBreakpoint } from '@alinta-digital/asg';

// colour found in newer ASG versions
const colourGrey9 = '#2A3A47';

const FooterBackground = styled.footer`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  background-color: ${colourGrey9};
  ${addBreakpoint(
    base.global.breakpoints.xs,
    `padding: 0 ${spacing().large}; 0 `,
    'up'
  )};
  ${addBreakpoint(
    base.global.breakpoints.sm,
    `padding: 0 ${spacing().medium};`,
    'up'
  )};
  ${addBreakpoint(base.global.breakpoints.md, `padding: 0 250px;`, 'up')};
`;

export default FooterBackground;
